module.exports = __webpack_public_path__ + "img/coupon_tutorial_gimmi04.6222eca5.png";